import React from 'react'
import { ToastContainer } from 'react-toastify';

const Toaster = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
      theme="dark"
      style={{ zIndex: 9999 }}
    />
  )
}

export default Toaster;
